export default __webpack_public_path__ + "9eaf56ede7c87feb71d05c921cce3eaa.png";